import { render, staticRenderFns } from "./PurchaseGiftCard.vue?vue&type=template&id=6848afb2&"
import script from "./PurchaseGiftCard.vue?vue&type=script&lang=js&"
export * from "./PurchaseGiftCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports